<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment';
import { onMounted } from "vue";
import recollectAutomationTable from "../../components/datatables/RecollectAutomationTable.vue";
import { downloadFile } from '@/utils/fileDownloader';

export default {
    page: {
        title: "ReCollect Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            dtKey:0,
            key: '',
            title: "ReCollect Submission",
            items: [
                {
                    text: "Finance",
                    href: "/",
                },
                {
                    text: "ReCollect Submission",
                    href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
            disableDownload: false,
            list:[],
            sourceFile: '',
            loadingDetail:true,
            loadingUpload:false,
            ButtonSeen:true,
            PLG_filename:'',
            waitingCountNo:0,
            CompletedCountCountNo:0,
            FaildCountNo:0,
            totalSubmission:0,
            date:'',
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        exportSubmissions(date){
            downloadFile(
                process.env.VUE_APP_AR_API_BASEURL + 'repayments/export/filtered-submissions?filterDate='+date,
                'recollect from '+ date + '.xlsx'
            );
        },
        

        setup() {
            onMounted(() => {
            const modal = document.querySelector(".bs-example-modal-lg");
            modal.addEventListener("show.bs.modal", (event) => {
                const button = event.relatedTarget; // Button that triggered the modal
                document.getElementById("modal-batch_id").textContent = button.getAttribute("data-batch_id") || "N/A";
                document.getElementById("modal-job_id").textContent = button.getAttribute("data-job_id") || "N/A";
                document.getElementById("modal-status").textContent = button.getAttribute("data-status") || "N/A";
            });
            });
        },

        search() {
            this.disableDownload = true;
            this.$refs.recollectTable.getlist(this.date);
        },
    },

    components: {
        Layout,
        PageHeader,
        // DataTable,
        recollectAutomationTable,
        flatPickr,
    },

    mounted() {
        // this.getlist();
    },

    
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card">



            <div class="card-body border-bottom-dashed border-bottom">
                <form @submit.prevent="submitForm" ref="searchCustomer">
                    <div class="row g-3 d-flex align-items-center justify-content-between">
                        <div class="col-xl-8 pb-3">
                            <div class="input-group">
                                <flat-pickr 
                                    v-model="date" 
                                    placeholder="Select Date" 
                                    :config="rangeDateconfig" 
                                    class="form-control" 
                                    aria-label="Recipient's username" 
                                    aria-describedby="button-addon2" 
                                />
                                <button 
                                    class="btn btn-outline-success material-shadow-none" 
                                    type="button" 
                                    id="button-addon2"
                                    @click="search"
                                >
                                    Search
                                </button>
                                
                                <button v-if="disableDownload"
                                    class="btn btn-outline-success material-shadow-none" 
                                    type="button" 
                                    id="button-addon2"
                                    @click="exportSubmissions(date)"
                                >
                                    Download List Submission
                                </button>
                            </div>
                        </div>
                        <div class="col-xl-4 pb-3 d-flex justify-content-end">
                            <router-link :to="'Recollect-Automation/New-Submission'" class="nav-link p-0">
                                <button class="btn btn-success">
                                    <i class="ri-command-fill align-middle me-1"></i> 
                                    New Submission
                                </button>
                            </router-link>
                        </div>
                    </div>
                    <!--end row-->
                </form>
            </div>



            <div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <!-- <h5 class="card-title mb-0">Recollect Submission</h5> -->
                        </div>
                    </div>
                    <div class="col-sm-auto">
                        <div>
                            
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div class="table-responsive">
                                <recollectAutomationTable
                                    ref="recollectTable"
                                    :filter-date="date"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>